function ProductDetails() {
    return (
        <h1>Product Details</h1>
    );
}
export default ProductDetails;